module.exports = __webpack_public_path__ + "img/P1-zh.ad1031ea.png";